<template>
  <div
    class="drop-zone"
    :class="{ active: isDragging, dragHover: dragHover }"
    @drop="onDrop($event)"
    @dragenter="dragHover = true"
    @dragleave="dragHover = false"
    @dragover.prevent
    @dragenter.prevent
  ></div>
</template>

<script>
export default {
  name: 'ProfileDropZone',

  props: {
    isDragging: {
      type: Boolean,
      required: false,
    },
    zoneIndex: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      dragHover: false,
    };
  },

  watch: {
    isDragging: function(newVal) {
      // watch it
      if (newVal === true) {
        this.dragHover = false;
      }
    },
  },

  methods: {
    onDrop(evt) {
      this.dragHover = false;
      this.$emit(
        'onDrop',
        this.zoneIndex,
        +evt.dataTransfer.getData('text/plain')
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.drop-zone {
  height: 5px;

  &.active {
    height: 20px;
    width: 100%;
    border: 1px dashed $brand-500;
    transition: 0.2s;

    &.dragHover {
      height: 100px;
      background-color: $brand-50;
      transition: 0.2s;
    }
  }
}
</style>
